import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OcCard, OcDownload } from "oc/components";

export const MyCafeteriaApplicationsCard = () => {
  const { t } = useTranslation();
  return (
    <Box id="my-cafeteria-benefits-card-card-statements">
      <OcCard label={t("MY_HR_APPLICATIONS")}>
        <Box>
          <OcDownload
            iconType="document"
            label="SZÉP kártya nyilatkozat"
            actionIconType="url"
            href={"#/my-cafeteria/szep-card-application"}
            isSmall={true}
            target={undefined}
          />
          <Box height="32px" />
          <OcDownload
            iconType="document"
            label="VBK nyilatkozat"
            actionIconType="url"
            href={"#/my-cafeteria/vbk-application"}
            isSmall={true}
            target={undefined}
          />
          <Box height="8px" />
        </Box>
      </OcCard>
    </Box>
  );
};

export default MyCafeteriaApplicationsCard;
